define([
    'jquery',
    'mage/translate',
    'moment',
    'mageUtils'
], function ($, __, moment, utils) {
    'use strict';

    return function () {
        $.validator.addMethod(
            'validate-full-date',
            function (value, params, additionalParams) {
                var test = moment(value, utils.convertToMomentFormat(additionalParams.dateFormat), true);

                return $.mage.isEmptyNoTrim(value) || test.isValid();
            },
            __('Please enter a valid date.')
        );
    };
});
